import { createFileRoute, redirect } from "@tanstack/react-router";

// Individual /scripts/* pages retired — 301 to the category catalogue.
export const Route = createFileRoute("/scripts/$slug")({
  beforeLoad: () => {
    throw redirect({ to: "/categories", statusCode: 301 });
  },
});
